import React, { useState, useEffect } from 'react';
import { Users, UserCheck, UserX, Calendar, Search, ChevronLeft, ChevronRight, MoreHorizontal, Eye, Ban, Trash2 } from 'lucide-react';
import { socket } from '../Containers/MainContainer';
import { Link } from 'react-router-dom';
import { numberWithCommas } from '../utils';

// Mock socket for demonstration - replace with your actual socket implementation
// const mockSocket = {
//   on: (event, callback) => {
//     setTimeout(() => {
//       if (event === 'response_get_admin_users') {
//         callback({
//           users: Array.from({ length: 10 }, (_, i) => ({
//             id: 1000 + i,
//             username: `user${1000 + i}`,
//             email: `user${1000 + i}@example.com`,
//             balance: Math.random() * 1000,
//             total_earned: Math.random() * 5000,
//             country: ['US', 'UK', 'CA', 'AU', 'DE'][Math.floor(Math.random() * 5)],
//             banned: Math.random() > 0.8 ? 'Yes' : 'No',
//             deleted: Math.random() > 0.9 ? 'Yes' : 'No',
//             join_date: new Date(Date.now() - Math.random() * 365 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
//             last_login: new Date(Date.now() - Math.random() * 30 * 24 * 60 * 60 * 1000).toISOString().split('T')[0]
//           })),
//           pagination: {
//             currentPage: 1,
//             totalPages: 25,
//             totalUsers: 247,
//             usersPerPage: 10
//           },
//           stats: {
//             totalUsers: 15420,
//             bannedUsers: 87,
//             deletedUsers: 45,
//             newUsersYesterday: 23,
//             bannedToday: 3,
//             bannedYesterday: 8
//           }
//         });
//       }
//     }, 500);
//   },
//   emit: (event, data) => {
//     console.log('Socket emit:', event, data);
//   }
// };

const AdminUsersDashboard = () => {
  const [users, setUsers] = useState([]);
  const [stats, setStats] = useState({});
  const [pagination, setPagination] = useState({});
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [viewMode, setViewMode] = useState('all');

useEffect(()=>{
  setLoading(true)
 socket.emit('getUsersAdmin', {
      username_like: searchTerm,
      page: currentPage,
      viewMode:viewMode
    });

},[viewMode])
  useEffect(() => {
    fetchUsers();
  }, [currentPage, searchTerm]);

  const fetchUsers = () => {
    setLoading(true);
    socket.emit('getUsersAdmin', {
      username_like: searchTerm,
      page: currentPage,
            viewMode:viewMode

    });

    socket.on('response_get_admin_users', (data) => {
      setUsers(data.users);
      setStats(data.stats);
      setPagination(data.pagination);
      setLoading(false);
    });
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const toggleSelectUser = (userId) => {
    setSelectedUsers(prev => 
      prev.includes(userId) 
        ? prev.filter(id => id !== userId)
        : [...prev, userId]
    );
  };

  const StatCard = ({ icon: Icon, title, value, subtitle, color = "blue" }) => (
    <div className="bg-gray-800 backdrop-blur-sm rounded-lg   p-3" >
    
          <div className="flex items-start flex-col gap-2">
      <div className="flex items-center justify-center gap-2">
           <div className={`p-1 rounded-lg `}>
          <Icon className={`h-5 w-5 text-${color}-600`} />
        </div>
         <div className="text-2xl font-bold text-gray-200" style={{fontSize:'18px'}}>{numberWithCommas(value)}</div>

      </div>
        <div className="">
          <div className="text-sm font-medium text-gray-200" style={{fontSize:'15px'}}>{title}</div>
         
          {subtitle && <p className="text-xs text-gray-500 mt-1" style={{fontSize:'10px'}}>{subtitle}</p>}
        </div>
      </div>
    </div>
  );

  const PaginationButton = ({ page, active, onClick, disabled, children }) => (
    <button
      onClick={() => onClick(page)}
      disabled={disabled}
      className={`px-3 py-2 text-sm font-medium rounded-md ${
        active
          ? 'bg-blue-600 text-white'
          : disabled
          ? 'bg-gray-900 text-gray-200 cursor-not-allowed'
          : 'bg-gray-900 text-gray-300 hover:bg-gray-800 '
      }`}
    >
      {children || page}
    </button>
  );

  const renderPagination = () => {
    const { currentPage, totalPages } = pagination;
    const pages = [];
    
    // Always show first page
    if (totalPages > 1) pages.push(1);
    
    // Show pages around current page
    for (let i = Math.max(2, currentPage - 1); i <= Math.min(totalPages - 1, currentPage + 1); i++) {
      if (!pages.includes(i)) pages.push(i);
    }
    
    // Always show last page
    if (totalPages > 1 && !pages.includes(totalPages)) pages.push(totalPages);

    return (
      <div className="flex items-center justify-between px-6 py-3  ">
        <div className="flex items-center text-sm text-gray-300">
          <span>
            Showing {((currentPage - 1) * pagination.usersPerPage) + 1} to{' '}
            {Math.min(currentPage * pagination.usersPerPage, pagination.totalUsers)} of{' '}
            {pagination.totalUsers} results
          </span>
        </div>
        <div className="flex items-center space-x-1">
          <PaginationButton
            page={currentPage - 1}
            onClick={handlePageChange}
            disabled={currentPage === 1}
          >
            <ChevronLeft className="h-4 w-4" />
          </PaginationButton>
          
          {pages.map((page, index) => (
            <React.Fragment key={page}>
              {index > 0 && pages[index - 1] !== page - 1 && (
                <span className="px-2 text-gray-500">...</span>
              )}
              <PaginationButton
                page={page}
                active={page === currentPage}
                onClick={handlePageChange}
              />
            </React.Fragment>
          ))}
          
          <PaginationButton
            page={currentPage + 1}
            onClick={handlePageChange}
            disabled={currentPage === totalPages}
          >
            <ChevronRight className="h-4 w-4" />
          </PaginationButton>
        </div>
      </div>
    );
  };

  return (
    <div className="min-h-screen bg-gray-900 text-white p-6 ">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-300">User Management</h1>
          <p className="mt-2 text-gray-200">Manage and monitor user accounts across your platform</p>
        </div>

        {/* Stats Grid */}
        <div className="overflow-x-auto w-full flex mb-4 gap-4">
          <StatCard
            icon={Users}
            title="Total Users"
            value={stats.totalUsers}
            color="blue"
          />
          <StatCard
            icon={UserCheck}
            title="New Yesterday"
            value={stats.newUsersYesterday}
            color="green"
          />
          <StatCard
            icon={UserX}
            title="Banned Users"
            value={stats.bannedUsers}
            color="red"
          />
          <StatCard
            icon={UserX}
            title="Banned Today"
            value={stats.bannedToday}
            color="orange"
          />
          <StatCard
            icon={UserX}
            title="Banned Yesterday"
            value={stats.bannedYesterday}
            color="yellow"
          />
          <StatCard
            icon={Trash2}
            title="Deleted Users"
            value={stats.deletedUsers}
            color="gray"
          />
        </div>
<div className="flex space-x-2 mb-4 overflow-x-auto">
  <button
              onClick={() => setViewMode('all')}
            className={`flex items-center space-x-1 px-3 py-1.5  rounded-lg text-sm transition-all ${
              viewMode === 'all'
                ? 'bg-blue-600 text-white shadow-lg' 
                : 'bg-gray-700/50 text-gray-300 hover:bg-gray-600/50'
            }`}
          >
          
            All Users
          </button>
          <button
              onClick={() => setViewMode('today')}
            className={`flex items-center space-x-1 px-3 py-1.5  rounded-lg text-sm transition-all ${
              viewMode === 'today'
                ? 'bg-blue-600 text-white shadow-lg' 
                : 'bg-gray-700/50 text-gray-300 hover:bg-gray-600/50'
            }`}
          >
            Joined Today
          </button>
          <button
              onClick={() => setViewMode('yesterday')}
            className={`flex items-center space-x-1 px-3 py-1.5  rounded-lg text-sm transition-all ${
              viewMode === 'yesterday'
                ? 'bg-blue-600 text-white shadow-lg' 
                : 'bg-gray-700/50 text-gray-300 hover:bg-gray-600/50'
            }`}
          >
            Joined Yesterday
          </button>
         <button
              onClick={() => setViewMode('topBalance')}
            className={`flex items-center space-x-1 px-3 py-1.5  rounded-lg text-sm transition-all ${
              viewMode === 'topBalance'
                ? 'bg-blue-600 text-white shadow-lg' 
                : 'bg-gray-700/50 text-gray-300 hover:bg-gray-600/50'
            }`}
          >
           Top Balances
          </button>
         
      </div>
            <div className="bg-gray-800/50 backdrop-blur-sm rounded-lg ">
          {/* Category Tabs */}
        {/* Search and Filters */}
        <div className=" rounded-lg shadow-sm  mb-6">
          <div className="p-6 ">
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
              <div className="relative flex-1 max-w-md">
                <Search className="absolute left-3 top-1/3 transform -translate-y-1/2 h-4 w-4 text-gray-300" />
                <input
                  type="text"
                  placeholder="Search by username or ID..."
                  value={searchTerm}
                  onChange={handleSearch}
                  className="pl-10 pr-4 py-2 w-full  bg-gray-900 text-gray-200  rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>
              <div className="flex items-center space-x-3">
                {selectedUsers.length > 0 && (
                  <span className="text-sm text-gray-600">
                    {selectedUsers.length} selected
                  </span>
                )}
               
              </div>
            </div>
          </div>

          {/* Users Table */}
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-gray-900">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    User
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Country
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Balance
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Total Earned
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Join Date
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Status
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody className=" divide-y divide-gray-200">
                {loading ? (
                  Array.from({ length: 10 }).map((_, i) => (
                    <tr key={i} >
                      <td className="px-3 py-3">
                        <div className="w-4 h-4 bg-gray-200 rounded animate-pulse"></div>
                      </td>
                      <td className="px-3 py-3">
                        <div className="h-4 bg-gray-200 rounded animate-pulse w-24"></div>
                      </td>
                      <td className="px-3 py-3">
                        <div className="h-4 bg-gray-200 rounded animate-pulse w-8"></div>
                      </td>
                      <td className="px-3 py-3">
                        <div className="h-4 bg-gray-200 rounded animate-pulse w-16"></div>
                      </td>
                      <td className="px-3 py-3">
                        <div className="h-4 bg-gray-200 rounded animate-pulse w-20"></div>
                      </td>
                      <td className="px-3 py-3">
                        <div className="h-4 bg-gray-200 rounded animate-pulse w-20"></div>
                      </td>
                      <td className="px-3 py-3">
                        <div className="h-4 bg-gray-200 rounded animate-pulse w-16"></div>
                      </td>
                      <td className="px-3 py-3">
                        <div className="h-4 bg-gray-200 rounded animate-pulse w-8"></div>
                      </td>
                    </tr>
                  ))
                ) : (
                  users.map((user) => (
                    <tr key={user.id} className=" hover:bg-gray-700/20 transition-colors">
                      
                      <td className="px-3 py-3">
                        <div>
                          <div className="text-sm font-medium text-gray-300">
                            ({user.id}) {user.username}
                          </div>
                          {user.email && (
                            <div className="text-sm text-gray-500">{user.email}</div>
                          )}
                        </div>
                      </td>
                      <td className="px-3 py-3 text-sm text-gray-300">
                        {user.country}
                      </td>
                      <td className="px-3 py-3 text-sm text-gray-300">
                        ${user.balance}
                      </td>
                      <td className="px-3 py-3 text-sm text-gray-300">
                        ${user.total_earned}
                      </td>
                      <td className="px-3 py-3 text-sm text-gray-300">
                        {user.join_date}
                      </td>
                      <td className="px-3 py-3">
                        <div className="flex space-x-2">
                          {user.banned === 'Yes' && (
                            <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800">
                              Banned
                            </span>
                          )}
                          {user.deleted === 'Yes' && (
                            <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800">
                              Deleted
                            </span>
                          )}
                          {user.banned === 'No' && user.deleted === 'No' && (
                            <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                              Active
                            </span>
                          )}
                        </div>
                      </td>
                      <td className="px-3 py-3">
                        <div className="flex items-center space-x-2">
                          <Link to={`/pluto/user/${user.id}`} className="text-green-300 hover:text-green-200">
                            <Eye className="h-5 w-5" />
                          </Link>

                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          {pagination.totalPages > 1 && renderPagination()}
        </div>
      </div></div>
    </div>
  );
};

export default AdminUsersDashboard;